import http from './request.js'
import config from '../config/index.js'

// 2.1 用户登录
const AppLogin = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/Login`, data);
}

// 2.2 获取socket 通信信息
const getScokect = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/DHSetting`, data);
}

// 2.3 获取左侧菜单
const getMenu = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/ParkChnlList`, data);
}

// 2.4 socket收到通知发后台
const callInNotify = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/InNotify`, data);
}

// 2.5 呼叫总数和详情通用
const allRingList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/AllRingList`, data);
}

// 2.6 接入事件
const callAnswer = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/Answer`, data);
}

// 2.7 接听接口
const callAnswering = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/Answering`, data);
}

// 2.8 事件完成挂机
const callHangUp = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/HangUp`, data);
}

// 2.9 获取备注信息
const getRemarkList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetRemarkList`, data);
}

// 2.10 设置备注信息
const setRemark = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/AddRemark`, data);
}

// 2.11 删除备注信息
const delRemark = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/DelRemark`, data);
}

// 2.13 模糊查询车牌
const getPlateList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/PlateList`, data);
}

// 2.14 修改车牌
const setPlateCorrect = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/PlateCorrect`, data);
}

// 2.15 获取当前事件操作消息接口
const getMessage = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetMessage`, data);
}

// 2.16 发送指令
const setMessage = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/SetEventHandle`, data);
}

// 2.17 获取呼叫处理首页抓拍图片接口
const getCapPicture = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetCapPic`, data);
}

// 2.18 获取当前客户所有场库信息功能(搜索条件下拉框)。
const getParkInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetParkInfo`, data);
}

// 2.19 通过搜索条件,获取车牌信息列表功能。
const getPlateCorrectList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetPlateCorrectList`, data);
}

// 2.20 通过搜索条件,获取车牌信息列表并导出功能
const exportPlateCorrect = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetPlateCorrectListExport`, data, {
    responseType: 'blob'
  });
}

//	2.21 手动修正异常车牌接口
const modifyPlateCode = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/ModifyPlateCode`, data);
}

//	2.22 获取呼叫记录
const getEventInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetEventInfoList`, data);
}

// 2.23 通过查询条件,导出呼叫记录信息
const exportGetEventInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetEventInfoListExport`, data, {
    responseType: 'blob'
  });
}

// 2.24 通过查询条件,获得车牌修改记录信息
const getLicensePlateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetLicensePlateInfoList`, data);
}

// 2.25 通过查询条件,导出车牌修改记录信息。
const exportGetLicensePlateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetLicensePlateInfoListExport`, data, {
    responseType: 'blob'
  });
}

// 2.26 通过查询条件,获得操作记录信息。
const getOperateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOperateInfoList`, data);
}

// 2.27 通过查询条件,导出操作记录信息。
const exportGetOperateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOperateInfoListExport`, data, {
    responseType: 'blob'
  });
}

// 2.28 更新支付状态。
const getPayStatus = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetPayStatus`, data);
}

//2.29用户退出接口
const AppLogOut = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/UserStatus/LogOut`, data);
}

//2.30用户离开接口
const AppUserLeave = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/UserStatus/UserLeave`, data);
}

//2.31通过查询条件,获得黑名单记录信息。
const getBlackPlateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetBlackPlateInfoList`, data);
}

// 2.32 通过查询条件,导出黑名单记录信息。
const exportGetBlackPlateInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetBlackPlateInfoListExport`, data, {
    responseType: 'blob'
  });
}

// 2.33 查找车辆月卡信息。
const getPlateCardInfo = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetPlateCardInfo`, data);
}

// 2.34 通道信息。
const getChnlInfo = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetChnlInfo`, data);
}

//2.35 获取rtc登录凭证
const getUserSig = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/WX/GetSignature`, data);
}

//2.36通过查询条件,获得设备在线记录信息。
const getOnlineInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOnlineInfoList`, data);
}

// 2.37 通过查询条件,导出设备在线记录信息。
const exportGetOnlineInfoList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOnlineInfoListExport`, data, {
    responseType: 'blob'
  });
}

// 2.38 通过查询条件,获得呼叫详情信息。
const getOperateInfoDetailList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOperateInfoDetailList`, data);
}

// 2.39 通过查询条件,导出呼叫记录信息
const exportGetOperateInfoDetailList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetOperateInfoDetailListExport`, data, {
    responseType: 'blob'
  });
}

//	2.40 获取呼叫时长
const getCallDurationList = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetCallDurationList`, data);
}

// 2.41 通过查询条件,导出呼叫时长信息
const getCallDurationListExport = (data) => {
  return http.post(`${config.http_url}/CSMApi/api/CallCenter/GetCallDurationListExport`, data, {
    responseType: 'blob'
  });
}

export default {
  AppLogin,
  getScokect,
  getMenu,
  callInNotify,
  allRingList,
  callAnswer,
  callAnswering,
  callHangUp,
  getRemarkList,
  setRemark,
  delRemark,
  getPlateList,
  setPlateCorrect,
  getMessage,
  setMessage,
  getCapPicture,
  getParkInfoList,
  getPlateCorrectList,
  exportPlateCorrect,
  modifyPlateCode,
  getEventInfoList,
  exportGetEventInfoList,
  getLicensePlateInfoList,
  exportGetLicensePlateInfoList,
  getOperateInfoList,
  exportGetOperateInfoList,
  getPayStatus,
  AppLogOut,
  AppUserLeave,
  getBlackPlateInfoList,
  exportGetBlackPlateInfoList,
  getPlateCardInfo,
  getChnlInfo,
  getUserSig,
  getOnlineInfoList,
  exportGetOnlineInfoList,
  getOperateInfoDetailList,
  exportGetOperateInfoDetailList,
  getCallDurationList,
  getCallDurationListExport,
}
